import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import sharedReducer from './SharedModule/Store/Reducers/AppReducer';
import loginReducer from './Modules/Login/Store/Reducers/LoginReducer';
import mfaCodeReducers from './Modules/MFA/Store/Reducers/MFACodeReducers';
import registrationReducer from './Modules/Registration/Store/Reducers/RegistrationReducer';
import resetProfileReducer from './Modules/ResetProfile/Store/Reducers/ResetProfileReducer';
import claimsReducer from './Modules/Claims/Store/Reducers/ClaimsReducer';
import feedbackReducer from './Modules/FeedBackReport/Store/Reducers/FeedBackReducer';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  sharedState: sharedReducer,
  loginState: loginReducer,
  registrationState: registrationReducer,
  resetProfileState: resetProfileReducer,
  claimsState: claimsReducer,
  feedbackState: feedbackReducer,
  mfaCodeReducers: mfaCodeReducers
});

const store = createStore(rootReducer, composeEnhancers(
  applyMiddleware(thunk)
));

const app = (
  <Provider store={store}>
    <App />
  </Provider>
);

ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
